export type HexacoPurchaseLocationState = {
  showInvalidPdfAlert?: boolean;
};

export const HEXACO_PURCHASE_INVALID_PDF_NAV_STATE: HexacoPurchaseLocationState =
  {
    showInvalidPdfAlert: true,
  };
